var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7948 11.6665C15.8298 11.6665 16.6689 12.5055 16.6689 13.5406V14.0201C16.6689 14.7653 16.4025 15.486 15.9179 16.0522C14.6101 17.5801 12.6208 18.3341 9.99965 18.3341C7.3781 18.3341 5.38976 17.5798 4.0845 16.0513C3.60137 15.4855 3.33594 14.7659 3.33594 14.022V13.5406C3.33594 12.5055 4.17498 11.6665 5.21 11.6665H14.7948ZM14.7948 12.9165H5.21C4.86534 12.9165 4.58594 13.1959 4.58594 13.5406V14.022C4.58594 14.4683 4.7452 14.9001 5.03508 15.2395C6.0795 16.4626 7.71773 17.0841 9.99965 17.0841C12.2816 17.0841 13.9212 16.4626 14.9683 15.2393C15.2591 14.8996 15.4189 14.4672 15.4189 14.0201V13.5406C15.4189 13.1959 15.1395 12.9165 14.7948 12.9165ZM9.99965 1.67041C12.3008 1.67041 14.1663 3.53589 14.1663 5.83708C14.1663 8.13826 12.3008 10.0037 9.99965 10.0037C7.69847 10.0037 5.83299 8.13826 5.83299 5.83708C5.83299 3.53589 7.69847 1.67041 9.99965 1.67041ZM9.99965 2.92041C8.38882 2.92041 7.08299 4.22625 7.08299 5.83708C7.08299 7.44791 8.38882 8.75374 9.99965 8.75374C11.6105 8.75374 12.9163 7.44791 12.9163 5.83708C12.9163 4.22625 11.6105 2.92041 9.99965 2.92041Z",
    fill: "#101828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.b714cd01258f7ea54b2560f95894a467.svg";
export { ForwardRef as ReactComponent };